import React, { useEffect, useState } from 'react';
import PortfolioItem from "../PortfolioItem";

const TravelCulture = () => {
    const [images, setImages] = useState([]);
    const subheading = "This section offers a visual journey into the world's diverse cultures and destinations.";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://mannuelportraitsapi-production.up.railway.app/api/photo-list");
                const data = await response.json();
                const filteredImages = data
                    .filter(item => item.category && item.category.name === "Travel & Culture")
                    .map(item => ({ id: item.id, imgSrc: item.image }));
                setImages(filteredImages);
            } catch (error) {
                console.error("Error fetching images:", error);
            }
        };

        fetchData();
    }, []); // Empty dependency array ensures useEffect runs only once on component mount

    return (
        <>
            <PortfolioItem title="Travel & Culture" images={images} subheading={subheading}/>
        </>
    );
};

export default TravelCulture;
